<template>
  <div :class="classes">
        <pt-page-title title="咨询商品预约工单导出历史"></pt-page-title>
        <pt-work-order-history-table :historyList="historyList" :params-data="paramsData" ref="table">
          <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text">
                   <a :href="$apiServer+'/mallsales/api/consultings/download-history/'+scope.row.id" target="_blank" :class="$style['view-report']">下载</a>
                </el-button>
              </template>
          </el-table-column>
      </pt-work-order-history-table>
  </div>
</template>

<script>
// 组件class前缀
import ptWorkOrderHistoryTable from '../../pt-work-order-history-table/withData'
import { historyList, tableLabels } from '../../work-order'
const prefixCls = 'pt-work-order-history'

export default {
  name: 'pt-work-order-history',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    ptWorkOrderHistoryTable
  },
  data () {
    return {
      params: {},
      historyList: historyList,
      paramsData: this.tableParams,
      tableLabels: tableLabels
    }
  }

}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.view-report{
text-decoration:none
}
</style>
